import { computeExpectedVaultAddress, HexString } from "@mass-money/sdk/web";
import { Button } from "../ui-kit/Button";
import { massApiUrl, useHash, useWallet } from "../utils/utils";
import { keccak256 } from "viem";
import { AUTHENTICATE_QUERY, GET_NONCE_QUERY } from "../queries/login.queries";
import { ethers } from "ethers";
import { useToken } from "../hooks/useToken";

declare var ethereum: any;

async function getNonce(address: string) {
  const result = await fetch(`${massApiUrl}/graphql`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      query: GET_NONCE_QUERY,
      variables: {
        address,
      }
    })
  }).then(res => res.json());

  return result;
}

async function authenticate(address: string, signature: HexString, message: string) {
  const result = await fetch(`${massApiUrl}/graphql`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      query: AUTHENTICATE_QUERY,
      variables: {
        address,
        signature,
        message
      }
    })
  }).then(res => res.json());
  return result;
}

const URL = 'https://alpha.mass.money';

async function signMessage(nonce: string, address: string, message: string) {
  const provider = new ethers.providers.Web3Provider(ethereum)
  
  try {
    const accounts = await provider.send('eth_requestAccounts', []);
    const signature = await provider.send('personal_sign', [message, accounts[0]]);
    return signature;
  } catch(e) {
    throw new Error(`Error signing message ${e}`)
  }
}

export function Connect({ isSmall }: { isSmall?: boolean }) {
  const [wallet, setAccounts] = useWallet();
  const { setToken } = useToken();
  const [, setHash] = useHash();

  const handleConnect = async () => {
    if (!wallet) {
      return;
    }
    try {
      const accounts = (await wallet.client.requestAddresses()).map(
        (account) => account.toLowerCase() as HexString
      );
      if (!accounts.length) {
        return;
      }
      const walletAddress = accounts[0];
      const vaultAddress = await computeExpectedVaultAddress({
        rpcUrl: wallet.net.rpc,
        creatorAddress: walletAddress,
        salt: keccak256(walletAddress),
      });
      const nonce = await getNonce(walletAddress);
      const message = `Please sign this message to show us it's really you. Also, make sure that you're authentifying from ${URL} official website.  \nAddress: 👉 ${walletAddress} 👈\n Nonce: ${nonce.data.auth.nonce}`;
      const signature = await signMessage(nonce.data.auth.nonce, walletAddress, message);
      const token = await authenticate(walletAddress, signature, message);
      setToken(token.data.auth.authenticate.token);
      setHash(vaultAddress);
      setAccounts(accounts);
    } catch (error) {
      console.error("Failed to connect", error);
    }
  };

  return (
    <Button
      size={isSmall ? "small" : "default"}
      onClick={handleConnect}
      isDisabled={!wallet}
    >
      Connect
    </Button>
  );
}
